@if (!currentPath.startsWith('/auth')) {
  <app-header></app-header>
}

<main [class.flex-fill]="!currentPath.startsWith('/auth')">
  <router-outlet></router-outlet>
</main>

@if (!currentPath.startsWith('/auth')) {
  <app-footer></app-footer>
}
